export default `
mutation DeleteBoundedContext($boundedContextId: ID!) {
  deleteBoundedContext(boundedContextId: $boundedContextId)
}

`
